define(['site', 'training-calendar', 'jquery'],
function(site,   trainingCalendar,    $) {

	'use strict';


	function liveClassClicked(event) {
		if (!event.disabled) {
			var buyURL = site.buyURLTemplate.replace("{partnum}", event.partNumber);

			// Open the link in the main window. (This might be the expanded calendar popup window.)
			var win = window;
			if (window.opener != null)
				win = window.opener;
			win.location.href = buyURL;

			// If this is the popup window, close it
			if (window.opener != null)
				window.close();
		}
		return false;
	}

	$(function() {
		//training explanation modal
		$("#show-training-explanation").click(function(){
			$("#training-explanation-modal").show();
		});

		$(".close-explanation").click(function() {
			$("#training-explanation-modal").hide();
		});

		trainingCalendar($('#training-calendar'), {
			eventClick: liveClassClicked,
			height: "auto"
		});

		// Use a popup window for the "Expand" link next to the calendar
		var popup = null;
		$('a.expand-training-calendar').click(function() {
			if (popup == null || popup.closed)
				popup = window.open(this.href, 'liveClassCalendarWindow', 'width=700,height=600');
			else
				popup.focus();
			return false;
		});


	//////////////////eLearning Popup Code/////////////////////////

		$(".popup-anchor").click(function() {
			$(this).closest(".popup-container")
				.removeClass("unclicked")
				.toggleClass("clicked");
		});
	});
});
